module.exports = __webpack_public_path__ + "img/chatbot5.aa84a174.svg";